
export const COLORS = {
  BLUE_100 : 'rgb(232, 240, 255, 0.5)',
  BLUE_200 : 'rgb(202, 217, 244, 0.5)',
  BLUE_300 : 'rgb(156, 181, 223, 0.5)',
  BLUE_400 : 'rgb(102, 136, 191, 0.5)',
  BLUE_500 : 'rgb(63, 107, 180, 0.5)',
  // Chart palette:
  // - Primary: SI-Blue-500 (Component blue)  #3F6BB4
  // - Hover: slightly darker (SI-Blue-600)  #003894
  BLUE_600 : 'rgb(63, 107, 180)',
  BLUE_700 : 'rgb(0, 56, 148)',
  BLUE_800 : 'rgb(0, 34, 89 ,0.5)',
  BLUE_900 : 'rgb(0, 22, 59, 0.5)',
};
